import React, { useState } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';
import { X } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export const DeletableEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
}) => {
  const { isDark } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const handleDelete = (evt) => {
    evt.stopPropagation();
    window.dispatchEvent(new CustomEvent('flow:delete-edge', { detail: { id } }));
  };

  const isActive = selected || isHovered;

  return (
    <>
      <g
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="cursor-pointer"
      >
        {/* Invisible wider stroke for easy clicking & hovering */}
        <path
          d={edgePath}
          fill="none"
          stroke="transparent"
          strokeWidth={30}
          className="react-flow__edge-interaction cursor-pointer"
        />

        {/* Visible animated line */}
        <BaseEdge
          path={edgePath}
          markerEnd={markerEnd}
          style={{
            ...style,
            strokeWidth: isActive ? 3 : 2,
            stroke: selected
              ? '#ef4444'
              : isHovered
              ? '#f59e0b'
              : (style.stroke || '#10b981'),
            strokeDasharray: '6,6',
            transition: 'stroke 0.2s, stroke-width 0.2s',
          }}
          interactionWidth={30}
        />
      </g>

      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
          className="nodrag nopan"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <button
            type="button"
            onClick={handleDelete}
            title="Click to Disconnect"
            aria-label="Disconnect line"
            className={`flex items-center justify-center rounded-full transition-all duration-200 shadow-md ${
              isActive
                ? 'h-6 w-6 bg-rose-500 text-white scale-110 hover:bg-rose-600 hover:scale-125 ring-2 ring-white/90 dark:ring-slate-900'
                : 'h-4 w-4 bg-slate-400/80 text-white opacity-40 hover:opacity-100 hover:h-6 hover:w-6 hover:bg-rose-500'
            }`}
          >
            <X className="h-3.5 w-3.5 stroke-[2.5]" />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
